import { useMemo } from 'react';

import { useWatch } from '@kanda-libs/ks-component-ts';
import type { FinanceRate } from '@kanda-libs/ks-frontend-services';

import {
  CREDIT_LINE_CLASS_NAMES as CLASS_NAMES,
  CreditLineClassNames,
} from './constants';

export interface CreditLineHook {
  classNames: CreditLineClassNames;
  isActive: boolean;
}

function useCreditLine(financeOption: FinanceRate): CreditLineHook {
  const formFinanceOption = useWatch({ name: 'financeOption' });

  const isActive: boolean = useMemo(
    () =>
      financeOption.name === formFinanceOption?.name &&
      financeOption.provider === formFinanceOption?.provider,
    [financeOption, formFinanceOption],
  );

  const classNames: CreditLineClassNames = useMemo(
    () => ({
      ...CLASS_NAMES,
      card: `${CLASS_NAMES.card} ${
        isActive ? 'border-purple-500' : 'border-neutral-400'
      }`,
    }),
    [isActive],
  );

  return {
    classNames,
    isActive,
  };
}

export default useCreditLine;
